// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1mNde","addWidgetButton":"Header_addWidgetButton__3l3Mp","dashboardTabs":"Header_dashboardTabs__2tALY","active":"Header_active__2l8j4"};